import { StarOutline } from '@material-ui/icons';
import { Rating } from '@material-ui/lab';
import { isObject, isNumber } from 'lodash';
import RatingView from './RatingView';
import InfoIcon from '@material-ui/icons/Info';
import { Tooltip, makeStyles } from '@material-ui/core';

const useToolTipStyles = makeStyles(() => ({
  tooltip: {
    color: 'white',
    backgroundColor: 'rgba(black, 0.2)',
    fontSize: '16px',
    padding: '10px',
    boxShadow: '2px 2px 10px 1px rgba(0,0,0,0.2)',
    borderRadius: '8px',
  },
  tooltipArrow: {
    color: 'rgba(black, 0.2)',
  },
}));

export default function OverallRatingCard({ ratingObj, from, to }) {
  const classes = useToolTipStyles();
  return (
    <div className='bg-white rounded p-4 mt-6'>
      <div className='text-lg font-medium mb-4 mx-4'>
        Overall {to} Rating By {from}
      </div>
      <div className='px-4'>
        {Object.keys(ratingObj || {})?.map(
          (param) =>
            param !== 'feedback' && (
              <div
                className='grid grid-cols-2 items-center rounded py-1.5 px-4 hover:bg-ab-primary dark:hover:bg-white hover:bg-opacity-10 dark:hover:bg-opacity-10'
                key={param}
              >
                <div>
                  <span className='opacity-60 capitalize'>{param}</span>
                  {ratingObj[param]?.description && (
                    <Tooltip
                      classes={{
                        tooltip: classes.tooltip,
                        arrow: classes.tooltipArrow,
                      }}
                      arrow
                      title={ratingObj[param]?.description}
                    >
                      <InfoIcon className='ml-5 cursor-help text-gray-400 text-opacity-60' />
                    </Tooltip>
                  )}
                </div>
                {isObject(ratingObj?.[param]) ? (
                  <RatingView parameter={param} rating={ratingObj?.[param]} />
                ) : isNumber(ratingObj?.[param]) ? (
                  <Rating
                    value={ratingObj?.[param] || 0}
                    emptyIcon={
                      <StarOutline color='inherit' className='opacity-60' />
                    }
                    readOnly
                  />
                ) : (
                  <span>-</span>
                )}
              </div>
            )
        )}
      </div>

      {ratingObj?.feedback && (
        <>
          <div className='font-medium mt-6 mx-8'>Feedback</div>
          <p className='opacity-80 mt-2 mx-8'>{ratingObj.feedback}</p>
        </>
      )}
    </div>
  );
}
